/**
 * Auto-generated file - do not edit manually
 * This file is generated by scripts/generate-version.js
 */

export const LIBRARY_NAME = "@dashgram/javascript"
export const LIBRARY_VERSION = "1.1.0"
export const LIBRARY_ORIGIN = "@dashgram/javascript@1.1.0"
